import * as React from 'react';
import * as styles from './ArrowIcon.css';
import { mergeStyles } from '@cian/utils';

interface IProps {
  direction: 'right' | 'left';
}

export const ArrowIcon = ({ direction }: IProps) => {
  // tslint:disable-next-line: no-implicit-dependencies
  const arrowIcon = require('!raw-loader!./assets/arrow.svg');

  return (
    <div
      dangerouslySetInnerHTML={{ __html: arrowIcon }}
      {...mergeStyles(styles['arrow'], styles[`arrow-${direction}`])}
    />
  );
};
